import { NgFor, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet, RouterLink, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserModuleService } from '../../services/user-module.service';

@Component({
  selector: 'app-navbar',
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

  userDetails: any;
  profileImage:any;

  constructor(private service: UserModuleService) { }

  ngOnInit(): void {
    const stored = localStorage.getItem('userDetails');
    this.userDetails = stored ? JSON.parse(stored) : null;

    this.getProfileById();
    
    
  }

   getProfileById() {
    this.service.getProfileById(this.userDetails.adminUser.adminUserId).subscribe(resp => {
      if (resp.status == 200) {
        this.profileImage = resp.body;
      }
    }, (error) => {
       if (error.status == 404) {
    
        this.profileImage = '/noprofile.svg';
      }
    })
  }


  // getUser() {
  //   this.service.getUserById(this.userId).subscribe(resp => {
  //     if (resp.status == 200) {
  //       this.userDetails = resp.body;
  //       console.log(this.userDetails);
  //     }
  //   }, (error) => {
  //     //console.log(error);

  //   })
  // }

  logout() {
    window.location.href = environment.baseLoginUrl;
    localStorage.clear()
  }

}
